import { useEffect, useRef, useState } from "react";

export function useInView(options = { threshold: 0.6 }) {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setInView(entry.isIntersecting);
            },
            options
        );

        if (ref.current) observer.observe(ref.current);

        return () => observer.disconnect();
    }, [options]);

    return [ref, inView];
}
